// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table .select-row[data-v-92ae9e00]{background:#f0f9eb}div[data-v-92ae9e00] .el-table__body-wrapper{max-height:348px!important}[data-v-92ae9e00] .el-table__header-wrapper{height:100%!important}", ""]);
// Exports
module.exports = exports;
